export default __webpack_public_path__ + "static/media/listEmpty@2x.fa9e69a3.png";